//a���� ����`���������`��
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

$(function () {
  const $bar = $("#wpadminbar");

  if ($bar[0]) {
    let isSc = false;

    $(window).on("load scroll", function (event) {
      if ($(window).scrollTop() > 10) {
        if (!isSc) {
          isSc = true;

          $bar.hide();
        }
      } else {
        if (isSc) {
          isSc = false;

          $bar.show();
        }
      }
    });
  }
});

$(function () {
  const $hdHome = $(".l-header.-home");

  if ($hdHome[0]) {
    let isSc = false;

    $(window).on("scroll", function (event) {
      run();
    });

    run();

    function run() {
      if ($(window).scrollTop() > 100) {
        if (!isSc) {
          isSc = true;

          $hdHome.stop().fadeOut(300);

          setTimeout(function () {
            $hdHome.removeClass("-home");
            $hdHome.stop().fadeIn(300);
          }, 300);
        }
      } else {
        if (isSc) {
          isSc = false;

          $hdHome.stop().fadeOut(300);

          setTimeout(function () {
            $hdHome.addClass("-home");
            $hdHome.stop().fadeIn(300);
          }, 300);
        }
      }
    }
  }
});

$(function () {
  const $parent = $(".p-hd__spNav a.-parent");

  if ($parent[0]) {
    const $wrap = $(".p-hd__spNavWrap");
    const $close = $(".p-hd__spNavClose");
    const $menu = $(".p-hd__spNavMenu");

    $parent.each(function (index, el) {
      $(this).click(function (event) {
        $(this).toggleClass("is-on");
        $(this).next().stop().slideToggle(300);
      });
    });

    $menu.click(function (event) {
      $wrap.addClass("is-show");
    });

    $close.click(function (event) {
      $wrap.removeClass("is-show");
    });
  }
});

$(function () {
  const $gotop = $(".p-ft__gotop");

  if ($gotop[0]) {
    const $online = $(".p-fixNav__online");
    let isSc = false;

    $(window).on("load scroll", function (event) {
      if ($(window).scrollTop() > 100) {
        if (!isSc) {
          isSc = true;

          $gotop.addClass("is-show");
          $online.addClass("is-sm");
        }
      } else {
        if (isSc) {
          isSc = false;

          $gotop.removeClass("is-show");
          $online.removeClass("is-sm");
        }
      }
    });
  }
});

$(function () {
  const $slider = $(".home-kv__sliderSlick");

  if ($slider[0]) {
    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      centerMode: true,
      variableWidth: true,
      arrows: true,
      dots: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });
  }
});

$(function () {
  $(".home-pages__sliderSlick").each(function (index, el) {
    const $slider = $(this);
    $slider.slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 2000,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });
  });
});

$(function () {
  const $slider = $(".home-ph__sliderSlick");

  if ($slider[0]) {
    $slider.slick({
      autoplay: true,
      autoplaySpeed: 2000,
      speed: 1000,
      centerMode: true,
      variableWidth: true,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
    });
  }
});

$(function () {
  const $slider = $(".home-topicsSpSlider__slick");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
      dots: true,
      arrows: false,
    });
  }
});

//�ץ����������
$(function () {
  const $root = $(".program-search");

  if ($root[0]) {
    const $selVal = $(".program-search__selVal");
    const $selValBtnLink = $(".program-search__inputBtns a");
    const $submit = $(".program-search__submit.-program a");
    const $submit2 = $(".program-search__submit2.-program a");
    const $submitHome = $(".program-search__submit.-home a");
    const $secWrap = $(".program-secWrap");
    const $secNone = $(".program-secNone");
    const $sec = $(".program-sec");
    const $col = $(".l-programPosts__col, .l-programPosts2__col");

    $selValBtnLink.click(function (event) {
      $(this).toggleClass("is-on");
    });

    const runSearch = function (type, value, value2) {
      //�������`��
      const scPos = $(".program-bg2").offset().top - $(".l-header").innerHeight();
      $("html, body").animate({ scrollTop: scPos }, 400, "swing");

      //һ����ʾ
      $sec.removeClass("is-hide");
      $col.removeClass("is-hide");

      if (type != "all" && type != "word") {
        //�g��
        $selVal.each(function (index, el) {
          const $t = $(this);
          const num = $t.attr("data-num");

          if ($t.hasClass("-select")) {
            const num2 = $t.find("option").filter(":selected").val();

            if (num2 != "") {
              $col.not(".s" + num + "-" + num2).addClass("is-hide");
            }
            //console.log('.s' + num + '-' + num2);
          } else if ($t.hasClass("-btn")) {
            let isOn = false;

            $t.find(".is-on").each(function (index, el) {
              isOn = true;
              $col.filter(".s" + num + "-" + $(this).attr("data-num")).addClass("is-hit");
              //ons += ' .s' + num + '-' + $(this).attr('data-num');
            });

            if (isOn) {
              $col.not(".is-hit").addClass("is-hide");
              $col.filter(".is-hit").removeClass("is-hit");
            }
          }
        });
      }

      //��`�ɗ���
      if (type == "word") {
        $col.each(function (index, el) {
          let wordTtl = $(this).attr("data-ttl");
          if (wordTtl.indexOf(value) != -1) {
            if (value2) {
              if ($(this).attr("data-ptype") == value2) {
                $(this).addClass("is-hit");
              }
            } else {
              $(this).addClass("is-hit");
            }
          }
        });

        $col.not(".is-hit").addClass("is-hide");
        $col.filter(".is-hit").removeClass("is-hit");
      }

      //�ץ������ID����
      if (type == "pid") {
        $col.each(function (index, el) {
          let pidData = $(this).attr("data-pid");
          let pids = value.split("_");

          for (let pidsI = 0; pidsI < pids.length; pidsI++) {
            if (pidData.indexOf(pids[pidsI]) != -1) {
              $(this).addClass("is-hit");
            }
          }
        });

        $col.not(".is-hit").addClass("is-hide");
        $col.filter(".is-hit").removeClass("is-hit");
      }

      if (type == "pol") {
        $col.each(function (index, el) {
          let polData = $(this).attr("data-pol");

          if (polData == value) {
            $(this).addClass("is-hit");
          }
        });

        $col.not(".is-hit").addClass("is-hide");
        $col.filter(".is-hit").removeClass("is-hit");
      }

      $sec.each(function (index, el) {
        if ($(this).find(".l-programPosts__col, .l-programPosts2__col").not(".is-hide").length == 0) {
          $(this).addClass("is-hide");
        }
      });

      if ($sec.not(".is-hide").length == 0) {
        $secNone.addClass("is-show");
      } else {
        $secNone.removeClass("is-show");
      }

      //ȫ���ʾ
      $secWrap.addClass("is-hide");
      setTimeout(function () {
        $secWrap.removeClass("is-hide");
      }, 100);
    };

    $submit.click(function (event) {
      runSearch();
    });

    $submit2.click(function (event) {
      runSearch("all");
    });

    const runLink = function () {
      let onList = [];

      $selVal.each(function (index, el) {
        const $t = $(this);
        const num = $t.attr("data-num");

        if ($t.hasClass("-select")) {
          const num2 = $t.find("option").filter(":selected").val();

          if (num2 != "") {
            onList.push(num + "-" + num2);
          }
        } else if ($t.hasClass("-btn")) {
          $t.find(".is-on").each(function (index, el) {
            onList.push(num + "-" + $(this).attr("data-num"));
          });
        }
      });

      let url = "/program/?sel=" + onList.join("_");
      window.location.href = url;
    };

    $submitHome.click(function (event) {
      runLink();
    });

    const runUrlGet = function () {
      var queryString = window.location.search;
      var queryObject = new Object();
      if (queryString) {
        queryString = queryString.substring(1);
        var parameters = queryString.split("&");

        for (var i = 0; i < parameters.length; i++) {
          var element = parameters[i].split("=");

          var paramName = decodeURIComponent(element[0]);
          var paramValue = decodeURIComponent(element[1]);

          queryObject[paramName] = paramValue;
        }
      }

      let list = queryObject["sel"];
      if (list) {
        const selVal = $(".program-search__selVal");

        list = list.split("_");

        for (var i = 0; i < list.length; i++) {
          let list2 = list[i].split("-");
          let num1 = list2[0];
          let num2 = list2[1];

          if (num1 && num2) {
            let tar = selVal.filter('[data-num="' + num1 + '"]');

            if (tar.hasClass("-select")) {
              tar.val(num2);
            } else if (tar.hasClass("-btn")) {
              tar.find('a[data-num="' + num2 + '"]').addClass("is-on");
            }
          }
        }
        runSearch();
      }

      let word = queryObject["word"];
      let ptype = queryObject["ptype"];
      if (word) {
        runSearch("word", decodeURI(word), ptype);
      }

      let pid = queryObject["pid"];
      if (pid) {
        runSearch("pid", pid);
      }

      let pol = queryObject["pol"];
      if (pol) {
        runSearch("pol", pol);
      }
    };
    runUrlGet();
  }
});

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function () {
  const $pro1 = $(".l-programPosts");

  if ($pro1[0]) {
    const $pro2 = $(".l-programPosts2");
    const $sel = $(".program-listSel__sel");
    const $pdf = $(".program-pdfPrint");

    $sel.on('change', function(event) {
      runChange($(this).val());
    });

    function runChange(val) {
      if(val == 'type2') {
        $pro1.hide();
        $pro2.stop().fadeIn();
        $pdf.stop().fadeIn();
      }

      if(val == 'type1') {
        $pro2.hide();
        $pro1.stop().fadeIn();
        $pdf.stop().fadeOut();
      }
    }
  }
});

$(function () {
  const $tab = $(".incentive-tab__item");

  if ($tab[0]) {
    let paramTab = getParam("tab");
    let paramTtl = getParam("title");

    if (paramTab > 1) {
      $tab.eq(paramTab - 1).trigger("click");
    }

    const $ttl = $(".incentive-section.is-show .incentive-section__subtitle");
    if (paramTtl) {
      $ttl.each(function (index, el) {
        let str = $(this).html();

        str = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
        str = str.replace(/\r?\n/g, "");
        str = str.replace(/ |��/g, "");

        paramTtl = paramTtl.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
        paramTtl = paramTtl.replace(/\r?\n/g, "");
        paramTtl = paramTtl.replace(/ |��/g, "");

        if (str == paramTtl) {
          let pos = $(this).offset().top;
          pos -= $(".l-header__fix").innerHeight();

          setTimeout(function () {
            $("html, body").animate({ scrollTop: pos }, 0, "swing");
          }, 10);

          setTimeout(function () {
            $("html, body").animate({ scrollTop: pos }, 0, "swing");
          }, 100);
        }
      });
    }
  }
});

$(function () {
  const tar = $(".ProgramTerms-Calendar__img img, .programDetail-calendar__img img");

  if (tar[0]) {
    const run = function () {
      if ($(window).innerWidth() < 768) {
        tar.each(function (index, el) {
          const $t = $(this);

          if (!$t.hasClass("is-wrap") && $t.innerWidth() / $t.innerHeight() > 1.63) {
            $t.addClass("is-wrap");
            if ($("body.single-program")[0]) {
              //�ץ������Ԕ��
              $t.wrap('<span class="u-spImgWSc2 -program"></span>').wrap('<span class="u-spImgWSc"></span>');
            } else {
              //�������Υک`��
              $t.wrap('<span class="u-spImgWSc2"></span>').wrap('<span class="u-spImgWSc"></span>');
            }
          }
        });
      }
    };
    run();

    setTimeout(function () {
      run();
    }, 100);

    setInterval(function () {
      run();
    }, 1000);
  }
});

$(function () {
  const $mokuji = $(".p-mokuji");

  if ($mokuji[0]) {
    const $tar = $(".js-mokuji__tar");
    let ttls = [];

    $tar.find("h2").each(function (index, el) {
      ttls.push($(this).html());
      $(this).attr("id", "title" + (index + 1));
    });

    if (ttls.length > 0) {
      $mokuji.addClass("is-show");
      let $list = $("<ul></ul>");
      $list.appendTo($mokuji);

      for (let i = 0; i < ttls.length; i++) {
        $list.append('<li><a href="#title' + (i + 1) + '">' + ttls[i] + "</a></li>");
      }

      $mokuji.find("a").click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top;

        position -= $(".l-header__fix").innerHeight();

        $("html, body").animate({ scrollTop: position }, speed, "swing");
        return false;
      });
    }
  }
});

$(function () {
  const $slider = $(".experiences__sliderSlick");
  const slickSettings = {
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1,
        settings: {
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false,
          arrows: false,
          dots: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          cssEase: "linear",
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  };
  $slider.slick(slickSettings);
  $(window).on("resize", function () {
    let w = window.innerWidth;
    if (w < 768 && !$slider.hasClass("slick-initialized")) {
      $slider.slick(slickSettings);
    }
  });
});

//add220315
$(function () {
  const $slider = $(".topics2-sliderSlick");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
      arrows: true,
      infinite: false
    });
  }
});
